import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useModalContext } from '@providers/ModalProvider';
import { SmsWhitelistService } from 'app/API';
import { useState } from 'react';

import { Content } from './CreateNewWhitelistNumber/styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
};

export const CreateNewWhitelistNumber = ({ onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { closeModal } = useModalContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [whitelist, setWhitelist] = useState({
    number: '',
  });

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await call(SmsWhitelistService.create({ requestBody: { number: whitelist.number } }));
    setIsSubmitting(false);
    closeModal();
    onSuccess();
  };

  return (
    <ModalWrapper width="370px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Whitelist mobile number</ModalTitle>
      <Content>
        <div className="input-wrapper">
          <div className="label">Mobile number</div>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setWhitelist({ ...whitelist, number: e.target.value })
            }
            label="Number with international prefix"
            placeholder='e.g. "+6588943230"'
            value={whitelist.number}
          />
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
